import React from 'react';

import PropTypes from 'prop-types';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import { Link } from 'react-router';

import { SafelyRenderHtml } from '@src/services';

import './ProductLinksCards.scss';

export const ProductLinksCards = (props) => {
    const {
        text = '',
        link = '#',
    } = props;

    const toLink = link.startsWith('/') ? link : `/products/${link}`;

    return (
        // className={`${styles.mini-products-line-container} ${createBlackBlockForSpaceIfNeeded(text)}`}
        <Col xs={12} md={6} lg={4} className="mini-products-line-container">
            <Card className="mini-products-line-card">
                <h3>
                    {SafelyRenderHtml(text)}
                </h3>
                <Link
                    className="btn btn-primary"
                    to={toLink}
                >
                    View
                </Link>
            </Card>
        </Col>
    );
};

ProductLinksCards.propTypes = {
    text: PropTypes.string,
    link: PropTypes.string,
};

export default ProductLinksCards;
